export const OFB_SEASON = '2024/25';
export const OFB_CURRENT_GW = 18;
export const OFB_TOTAL_GW = 26;
export const OFB_STANDINGS = [
    { pos:1, name:'St. Polten',      short:'STP', color:'#6B2D8B', p:18, w:14, d:2, l:2, gf:52, ga:18, form:['W','W','W','D','W'], zone:'cl',  pts:44 },
    { pos:2, name:'Sturm Graz',      short:'STU', color:'#000000', p:18, w:12, d:3, l:3, gf:44, ga:22, form:['W','D','W','W','L'], zone:'cl',  pts:39 },
    { pos:3, name:'Neulengbach',     short:'NEU', color:'#006400', p:18, w:10, d:3, l:5, gf:36, ga:28, form:['W','W','L','D','W'], zone:'cl',  pts:33 },
    { pos:4, name:'Bergheim',        short:'BER', color:'#CC0000', p:18, w:9,  d:2, l:7, gf:30, ga:30, form:['L','W','W','D','W'], zone:'',    pts:29 },
    { pos:5, name:'Altenmarkt',      short:'ALT', color:'#003399', p:18, w:7,  d:3, l:8, gf:26, ga:32, form:['W','L','D','W','L'], zone:'',    pts:24 },
    { pos:6, name:'Austria Wien F',  short:'AUW', color:'#6B0CA8', p:18, w:6,  d:2, l:10,gf:22, ga:36, form:['L','W','L','D','W'], zone:'',    pts:20 },
    { pos:7, name:'Innsbruck',       short:'INN', color:'#CC0000', p:18, w:3,  d:3, l:12,gf:16, ga:42, form:['L','L','D','L','W'], zone:'rel', pts:12 },
    { pos:8, name:'Wacker Innsbruck',short:'WAC', color:'#000000', p:18, w:2,  d:2, l:14,gf:12, ga:52, form:['L','L','L','D','L'], zone:'rel', pts:8  },
];
export const OFB_SCORERS = [
    { name:'Laura Feiersinger', initials:'LF', club:'St. Polten',  goals:12 },
    { name:'Nicole Billa',      initials:'NB', club:'Sturm Graz',  goals:11 },
    { name:'Sarah Puntigam',    initials:'SP', club:'St. Polten',  goals:9  },
    { name:'Viktoria Pinther',  initials:'VP', club:'Neulengbach', goals:8  },
    { name:'Julia Hickelsberger',initials:'JH',club:'Bergheim',    goals:7  },
];
export const OFB_FIXTURES = [
    { date:'2025-03-08', home:'St. Polten',  away:'Sturm Graz',  homeGoals:2, awayGoals:1, status:'FT', homeColor:'#6B2D8B', awayColor:'#000000' },
    { date:'2025-03-15', home:'Bergheim',    away:'Neulengbach', homeGoals:1, awayGoals:2, status:'FT', homeColor:'#CC0000', awayColor:'#006400' },
    { date:'2025-03-22', home:'Sturm Graz',  away:'Bergheim',    homeGoals:3, awayGoals:0, status:'FT', homeColor:'#000000', awayColor:'#CC0000' },
    { date:'2025-04-26', home:'St. Polten',  away:'Neulengbach', homeGoals:0, awayGoals:0, status:'NS', homeColor:'#6B2D8B', awayColor:'#006400' },
    { date:'2025-05-03', home:'Sturm Graz',  away:'Altenmarkt',  homeGoals:0, awayGoals:0, status:'NS', homeColor:'#000000', awayColor:'#003399' },
];
export function ofbPts(t) { return t.w * 3 + t.d; }
export function ofbGD(t)  { return t.gf - t.ga; }

export async function fetchLiveOFBData() {
    const PROXY_URL = 'https://ofb-proxy.footballgirl.workers.dev';
    try {
        const res = await fetch(PROXY_URL, { signal: AbortSignal.timeout(5000) });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        if (!data.standings || !data.standings.length) throw new Error('empty');
        return {
            standings: data.standings,
            scorers:   OFB_SCORERS,
            fixtures:  OFB_FIXTURES,
        };
    } catch (e) {
        console.warn('[fetchLiveOFBData] proxy failed, using fallback:', e.message);
        return null;
    }
}
